import { createI18n } from "vue-i18n";

export default createI18n({
  //legacy: true,
  locale: "pt-br",
  //fallbackLocale: ["pt-br"],
  messages: {
    "pt-br": {
      message: {
        PageNotFound: "Página não encontrada",
        components: {
          githubActivity: {
            stats: "Github Stats & Atividade",
            followers: "Seguidores",
            following: "Seguindo"
          },
          twitterTimeline: {
            stats: "Twitter Stats & Timeline",
            tweets: "Tweets",
            favourites: "Favoritos",
            followers: "Seguidores",
            following: "Seguindo"
          }
        },
        template: {
          hero: {
            subtitle: "Concatenador de strings senior fullstack :/ :\\ :D"
          },
          footer: {
            left: {
              title: "Minimalista?",
              subtext:
                "Acredito que menos é mais. Partindo de pequenos (e simples) blocos é que foram construídos os mais longos impérios. Se concordas comigo, manda um alô no twitter. Feedback positivo apenas!"
            },
            right: {
              title: "Construido com:"
            }
          }
        },
        views: {
          home: {
            title: "Início"
          },
          projects: {
            title: "Projetos",
            subtitle: "se servir para concatenar duas strings, eu já usei.",
            showMore: "Exibir mais"
          },
          about: {
            title: "Sobre mim",
            subtitle:
              "Brasileiro, natural de Fortaleza/CE, moro em João Pessoa/PB desde 2005. Bacharel em Computação, com mais de 10 anos de experiência com engenharia de software, em especial com a plataforma Java.",
            timeline: "Linha do tempo"
          }
        },
        hello: "Olá mundo"
      }
    },
    "en-us": {
      PageNotFound: "Page not found",
      message: {
        components: {
          githubActivity: {
            stats: "Github Stats & Activity",
            followers: "Followers",
            following: "Following"
          },
          twitterTimeline: {
            stats: "Twitter Stats & Timeline",
            tweets: "Tweets",
            favourites: "Favorites",
            followers: "Followers",
            following: "Following"
          }
        },
        template: {
          hero: {
            subtitle: "String concatenator senior fullstack :/ :\\ :D"
          },
          footer: {
            left: {
              title: "Minimalistic?",
              subtext:
                "I believe that less is more. Starting from small (and simple) blocks, the longest empires were built. If you agree with me, say hello on twitter. Positive feedback only!"
            },
            right: {
              title: "Built with:"
            }
          }
        },
        views: {
          home: {
            title: "Home"
          },
          projects: {
            title: "Projects",
            subtitle:
              "if it serves to concatenate two strings, i have already used it.",
            showMore: "Show more"
          },
          about: {
            title: "About me",
            subtitle:
              "Brazilian, born in Fortaleza (Ceará), but living in João Pessoa (Paraíba) since 2005. Bachelor in Computer Sciences, with more than 10 years of experience with software engineering, especially with the Java platform.",
            timeline: "Timeline"
          }
        },
        hello: "Hello world!"
      }
    }
  }
});
